import { BadRequestError } from "./bad-request-error";

// Thrown when a note would be written with neither text nor a single attachment. A note is one or
// the other and needs only one of the two — a photograph says what it needs to without a sentence
// beside it — but neither is nothing, and an empty row in a thread is noise no reader can act on.
// 400 rather than 409: nothing has moved under the caller, the payload itself says nothing. Both
// clients hide their send button in that state, so reaching here means the guard is the last one
// standing.
export class EmptyNoteError extends BadRequestError {
	constructor() {
		super("notes.note_is_empty");
		this.name = "EmptyNoteError";
	}
}
